module.exports = __webpack_public_path__ + "img/fb.cb661a24.jpg";